Ext.define('SA.view.mapexport.overlay.AbstractEditWindow', {
    extend: 'SA.view.SimpleContainer',

    baseCls: 'sa-abstract-edit-window',
    floating: true,

    initComponent() {
        this.callParent();

        this.mon(Ext.getDoc(), 'mousedown', this.onDocMouseDown, this);
    },

    onDocMouseDown(ev, target) {
        var comps = this.query('*');

        comps.push(this);

        if (comps.some(comp => comp.el && comp.el.contains(target))) {
            return;
        }

        this.destroy();
    }
});